import React, { useEffect, useState } from 'react';
import TablaRutas from './TablaRutas';
import { getRutas } from '../../services/routes_monit/routes_monit.service';

const RouteMonit = () => {
  const [rutas, setRutas] = useState([]);

  const fetchRutas = async () => {
    try {
      const response = await getRutas();
      setRutas(response || []);
    } catch (error) {
      console.error('Error cargando rutas:', error);
    }
  };

  useEffect(() => {
    fetchRutas();

    const interval = setInterval(fetchRutas, 180000); // 3 minutos
    return () => clearInterval(interval);
  }, []);

  return <TablaRutas rutas={rutas} />;
};

export default RouteMonit;
